import { styled } from "styled-components";
import { IsDarkModeProp } from "../../Components/common/types";
import searchDark from "../../assets/images/searchDark.png";
import searchWhite from "../../assets/images/searchWhite.png";

const SearchWrapper = styled.div`
// border: 1px solid red;
  border-radius: 27px;
  display: flex;
  align-items: center;
  position: relative;
    @media (max-width: 992px) {
    width: 70%;;
  }
    @media (max-width: 768px) {
    width: 100%;;
  }
  width: 45%;
`;

const SearchInput = styled.input.attrs({ type: "search" })`
background-color: ${({theme}) => theme.searchInputBcg};
  width: 100%;
  padding: 15px 23px 15px 50px;
  border: 1px solid ${({theme}) => theme.searchInputBdrClr};
  border-radius: 27px;
  font-size: 14px;
  color: ${({theme}) => theme.text};

    &:hover {
    border-color: ${({theme}) => theme.searchInputBdrClrHver};
    background-color: ${({theme}) => theme.searchInputBcgClrHver};
  }

  &:focus {
    outline: none;
    border-color: ${({theme}) => theme.text};
     background-color: ${({theme}) => theme.searchInputBcgClrHver};
  }

  /* Style the clear (x) button */
  &::-webkit-search-cancel-button {
    -webkit-appearance: none; /* Remove default styling */
    appearance: none;
    background-color: ${({theme}) => theme.circularIconBgt};
    border: 1px solid ${({theme}) => theme.text};
    border-radius: 50%;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }


  /* On hover over the clear button */
  &::-webkit-search-cancel-button:hover {
    background-color: #ff0000;
  }
`;

const SearchIcon = styled.img`
  position: absolute;
  left: 20px;
  width: 24px;
  height: 24px;
 
`;

export function SearchBar({isDarkMode}: IsDarkModeProp) {

  return (
    <SearchWrapper>
      <SearchIcon src={isDarkMode? searchWhite: searchDark}/>
      <SearchInput placeholder="Search projects" name="search"/>
    </SearchWrapper>
  );
}

export default SearchBar;